import React, { Fragment, ReactElement } from 'react';
import {
  Avatar,
  Box,
  Grid,
  Button,
  Paper,
  Typography,
  Card,
  CardActions,
  CardContent,
} from '@material-ui/core';
import useStyles from './styles';

import PropTypes from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';
import _ from 'lodash';
import VerifiedUserIcon from '@material-ui/icons/PersonAdd';
import NotVerifiedUserIcon from '@material-ui/icons/PersonAddDisabled';
import ErrorIcon from '@material-ui/icons/Error';
import ActiveRegistrationsIcon from '@material-ui/icons/HowToReg';
import ExcludedRegistrationsIcon from '@material-ui/icons/PausePresentation';
import NewRegistrationsIcon from '@material-ui/icons/FiberNew';
import UpdateRequestsIcon from '@material-ui/icons/Update';
import ActiveVatReturnsIcon from '@material-ui/icons/PlaylistAddCheck';
import EuroSymbolIcon from '@material-ui/icons/EuroSymbol';
import NoteAddIcon from '@material-ui/icons/NoteAdd';

interface IProps {
  name: string;
  description: string;
  color: string;
  value: string;
  barPercentage: number;
  iconName: string;
  showBar: boolean;
}

export default function KPI(props: IProps) {
  const classes = useStyles();

  return (
    <>
      <Card className={classes.root}>
        <CardContent>
          <Grid container spacing={0}>
            <Grid item xs={10}>
              <Typography
                className={classes.title}
                color="textSecondary"
                gutterBottom
              >
                {props.name}
              </Typography>
              {props.name != 'Pending' && (
                <Typography variant="h4" component="h2">
                  {props.value}
                </Typography>
              )}

              {props.name === 'Pending' && (
                <Typography
                  variant="h4"
                  component="h2"
                  style={{ color: props.color }}
                >
                  {props.value}
                </Typography>
              )}
            </Grid>
            <Grid item xs={2} style={{ textAlign: 'right' }}>
              {/* <Avatar
                aria-label="recipe"
                className={(classes.avatar, classes.large)}
              > */}
              {getIcon(props.iconName, classes, props.color)}
              {/* </Avatar> */}
            </Grid>
          </Grid>

          {/* <Typography className={classes.pos} color="textSecondary">
            adjective
          </Typography> */}
          <Box height={'40px'} alignContent={'center'}>
            <Typography variant="caption" component="p">
              {props.description}
            </Typography>
          </Box>

          {props.showBar && (
            <LinearProgressWithLabel
              value={props.barPercentage}
              color={props.color}
              classes={classes}
            />
          )}
        </CardContent>
      </Card>
    </>
  );
}

function getIcon(iconName: string, classes: any, color: string) {
  switch (iconName) {
    case 'verifiedUsers':
      return (
        <VerifiedUserIcon fontSize="large" className={classes.greenIcon} />
      );
    case 'notVerifiedUsers':
      return (
        <NotVerifiedUserIcon fontSize="large" className={classes.orangeIcon} />
      );
    case 'incomingMessageErrors':
      return <ErrorIcon fontSize="large" className={classes.redIncon} />;
    case 'technicalErrorMessages':
      return <ErrorIcon fontSize="large" className={classes.redIcon} />;
    case 'activeRegistrations':
      return (
        <ActiveRegistrationsIcon
          fontSize="large"
          className={classes.greenIcon}
        />
      );
    case 'excludedRegistrations':
      return (
        <ExcludedRegistrationsIcon
          fontSize="large"
          className={classes.orangeIcon}
        />
      );
    case 'newRegistrations':
      return (
        <NewRegistrationsIcon fontSize="large" className={classes.blueIcon} />
      );
    case 'updateRequests':
      return (
        <UpdateRequestsIcon fontSize="large" className={classes.purpleIcon} />
      );
    case 'activeVatReturns':
      return (
        <ActiveVatReturnsIcon fontSize="large" className={classes.greenIcon} />
      );
    case 'vatPayableAmount':
      return <EuroSymbolIcon fontSize="large" className={classes.blueIcon} />;
    case 'vatReturnsCounts':
      return (
        <NoteAddIcon
          fontSize="large"
          className={
            color === 'orange' ? classes.orangeIcon : classes.greenIcon
          }
        />
      );
    case 'paymentsPending':
      return (
        <EuroSymbolIcon
          fontSize="large"
          className={color === 'red' ? classes.redIcon : classes.greenIcon}
        />
      );
    case 'paymentsPaid':
      return <EuroSymbolIcon fontSize="large" className={classes.blueIcon} />;
    case 'payableAmount':
      return <EuroSymbolIcon fontSize="large" className={classes.blueIcon} />;
    case 'paymentsAllocated':
      return <EuroSymbolIcon fontSize="large" className={classes.greenIcon} />;
    case 'amountAllocated':
      return <EuroSymbolIcon fontSize="large" className={classes.orangeIcon} />;
    default:
      return <VerifiedUserIcon fontSize="large" className={classes.blueIcon} />;
  }
}

function getBarColors(
  color: string,
  classes: any
): { colorPrimary: any; barColorPrimary: any } {
  switch (color) {
    case 'green':
      return {
        colorPrimary: classes.greenColor,
        barColorPrimary: classes.greenBarColor,
      };
    case 'red':
      return {
        colorPrimary: classes.redColor,
        barColorPrimary: classes.redBarColor,
      };
    case 'orange':
      return {
        colorPrimary: classes.orangeColor,
        barColorPrimary: classes.orangeBarColor,
      };
    case 'blue':
      return {
        colorPrimary: classes.blueColor,
        barColorPrimary: classes.blueBarColor,
      };
    case 'purple':
      return {
        colorPrimary: classes.purpleColor,
        barColorPrimary: classes.purpleBarColor,
      };
    default:
      return {
        colorPrimary: '',
        barColorPrimary: '',
      };
  }
}

function LinearProgressWithLabel(props: {
  value: number;
  color: string;
  classes: any;
}) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress
          variant="determinate"
          value={props.value}
          classes={getBarColors(props.color, props.classes)}
        />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${
          props.value ? Math.round(props.value) : 0
        }%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};
